module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.keyboardOpen) ? _c('div', {
    staticClass: "fixed bottom-0 left-0 w-100 pt3 pb4 ph3 ph4-ns bg-white silver flex justify-between shadow-4 z-999 dn-xl"
  }, [_c('div', {
    staticClass: "flex-basis-2 tc"
  }, [_c('router-link', {
    staticClass: "no-underline",
    class: _vm.dashboardRoute ? 'color-theme' : 'silver',
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    staticClass: "feather feather-home",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "19",
      "height": "19",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "9 22 9 12 15 12 15 22"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "db f7 pt1"
  }, [_vm._v(_vm._s(_vm.$t('menu.home', {
    home: 'Home'
  })))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-basis-2 tc"
  }, [_c('router-link', {
    staticClass: "no-underline",
    class: _vm.devicesRoute ? 'color-theme' : 'silver',
    attrs: {
      "to": "/devices"
    }
  }, [_c('svg', {
    staticClass: "feather feather-shield",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 22s8-4 8-10V4l-8-2-8 2v8c0 6 8 10 8 10z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "db f7 pt1"
  }, [_vm._v(_vm._s(_vm.$t('menu.items', {
    items: 'Items'
  })))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-basis-2 tc"
  }, [_c('router-link', {
    staticClass: "no-underline",
    class: _vm.claimsRoute ? 'color-theme' : 'silver',
    attrs: {
      "to": _vm.featureFlagRedirectClaimV2 ? '/claims-v2' : '/claims'
    }
  }, [_c('svg', {
    staticClass: "feather feather-file-text",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "14 2 14 8 20 8"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "13",
      "x2": "8",
      "y2": "13"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "17",
      "x2": "8",
      "y2": "17"
    }
  }), _c('polyline', {
    attrs: {
      "points": "10 9 9 9 8 9"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "db f7 pt1"
  }, [_vm._v(_vm._s(_vm.$t('menu.claims', {
    claims: 'Claims'
  })))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-basis-2 tc"
  }, [_c('router-link', {
    staticClass: "no-underline",
    class: _vm.accountRouteNew ? 'color-theme' : 'silver',
    attrs: {
      "to": "/account"
    }
  }, [_c('svg', {
    staticClass: "feather feather-user",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "19",
      "height": "19",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }
  }), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "db f7 pt1"
  }, [_vm._v(_vm._s(_vm.$t('menu.account', {
    account: 'Account'
  })))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-basis-2 tc"
  }, [_c('router-link', {
    staticClass: "no-underline",
    class: _vm.supportRoute ? 'color-theme' : 'silver',
    attrs: {
      "to": "/contact"
    }
  }, [_c('svg', {
    staticClass: "feather feather-help-circle",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "19",
      "height": "19",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12",
      "y2": "17"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "db f7 pt1"
  }, [_vm._v(_vm._s(_vm.$t('appmenu.support', {
    support: 'Support'
  })))])])], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e648865", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e648865","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 1406
// module chunks = 0